export const getRandomColor = () =>
  `rgb(${Math.floor(Math.random() * 255)}, ${Math.floor(
    Math.random() * 255,
  )},${Math.floor(Math.random() * 255)})`
